export const ADAPTER_GUIDE_DEFAULT_WIDTH = 416;
export const ADAPTER_GUIDE_MIN_WIDTH = 352;
export const ADAPTER_GUIDE_PUSH_MAX_WIDTH = 512;
export const ADAPTER_GUIDE_MAX_WIDTH = 768;
export const ADAPTER_GUIDE_KEYBOARD_STEP = 32;
export const ADAPTER_GUIDE_WIDTH_STORAGE_KEY = "decisively.adapterGuide.width";

export type AdapterGuideResizeKey = "ArrowLeft" | "ArrowRight" | "Home" | "End";

export const clampAdapterGuideWidth = (width: number): number =>
  Math.min(ADAPTER_GUIDE_MAX_WIDTH, Math.max(ADAPTER_GUIDE_MIN_WIDTH, Math.round(width)));

export const parseAdapterGuideWidth = (value: string | null): number => {
  if (value === null || value.trim() === "") return ADAPTER_GUIDE_DEFAULT_WIDTH;
  const parsedWidth = Number(value);
  return Number.isFinite(parsedWidth) ? clampAdapterGuideWidth(parsedWidth) : ADAPTER_GUIDE_DEFAULT_WIDTH;
};

export const getAdapterGuideReservedWidth = (width: number): number =>
  Math.min(clampAdapterGuideWidth(width), ADAPTER_GUIDE_PUSH_MAX_WIDTH);

export const getAdapterGuideDragWidth = (startWidth: number, startX: number, currentX: number): number =>
  clampAdapterGuideWidth(startWidth + startX - currentX);

export const getAdapterGuideKeyboardWidth = (width: number, key: AdapterGuideResizeKey): number => {
  if (key === "Home") return ADAPTER_GUIDE_MIN_WIDTH;
  if (key === "End") return ADAPTER_GUIDE_MAX_WIDTH;
  return clampAdapterGuideWidth(width + (key === "ArrowLeft" ? ADAPTER_GUIDE_KEYBOARD_STEP : -ADAPTER_GUIDE_KEYBOARD_STEP));
};
